import moment from 'moment'
import { normalizeCinemaId } from './cinemaList'
import { CINEMA_TYPE, CINEMA_TYPE_PROPERTY } from '../../pages/Hall/constants'

export const delay = (ms = 15000) => new Promise((res) => setTimeout(res, ms))

export const formatTime = (dateString) => moment(dateString).format('HH:mm')

export const formatDate = (dateString) => moment(dateString).format('D. M. YYYY')

export const formatRelativeDay = (dateString) => {
    const date = moment(dateString)
    const today = moment().startOf('day')
    const tomorrow = moment().startOf('day').add(1, 'days')

    if (date.isSame(today, 'day')) {
        return 'today'
    } else if (date.isSame(tomorrow, 'day')) {
        return 'tomorrow'
    } else {
        return date.format('D. M. YYYY')
    }
}

export const convertStringToBoolean = (strOrBoolean) => {
    switch (strOrBoolean.toString()) {
        case 'true':
            return true
        case 'false':
            return false
        default:
            throw new Error('Invalid input: input must be either "true" or "false"')
    }
}

export const getCinemaType = (array) => {
    if (array?.includes(CINEMA_TYPE_PROPERTY.GOLD_CLASS)) return CINEMA_TYPE.GOLD_CLASS

    if (array?.includes(CINEMA_TYPE_PROPERTY.DELUXE) || array?.includes(CINEMA_TYPE_PROPERTY.DELUXE_FAMILY)) {
        return CINEMA_TYPE.DELUXE
    }

    if (array?.includes(CINEMA_TYPE_PROPERTY.BOUTIQUE)) {
        return CINEMA_TYPE.BOUTIQUE
    }

    // if (array?.includes(CINEMA_TYPE_PROPERTY.CSFD)) return CINEMA_TYPE.CSFD //TODO when will be some csfd design

    return CINEMA_TYPE.DEFAULT
}

export const findCinemaId = (state) => {
    const cinemaid =
        normalizeCinemaId(state?.pages?.hall?.movie?.data?.cinemaid) ??
        normalizeCinemaId(state?.components?.basket?.data?.cinemaid) ??
        normalizeCinemaId(localStorage.getItem('cinemaid'))

    return cinemaid ?? 0
}

export const findEventId = (state) => {
    const eventid = state?.pages?.hall?.movie?.data?.eventid ?? localStorage.getItem('eventid') ?? null

    return +eventid
}

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant',
    })
}

export function downloadPDF(fileData, fileName) {
    const linkSource = `data:application/pdf;base64,${fileData}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
}
